/* prestige.js v11 — perf-optimized: reduce-motion + mobile-aware
================================================================ */
(function(){
'use strict';

var reduceMotion=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var isMobile=window.matchMedia&&window.matchMedia('(max-width: 768px)').matches;

function initPageEnter(){
  var v=document.getElementById('page-veil');
  if(v)setTimeout(function(){v.classList.add('gone');},80);
}

function killPayment(){
  ['shopify-payment-terms','.shopify-payment-button','[data-shopify-buttoncontainer]'].forEach(function(s){
    document.querySelectorAll(s).forEach(function(el){el.remove();});
  });
  document.querySelectorAll('*').forEach(function(el){
    try{if(!el.children.length&&el.textContent&&el.textContent.trim().startsWith('Moyens de paiement'))el.remove();}catch(e){}
  });
}
killPayment();
[200,800,2000].forEach(function(d){setTimeout(killPayment,d);});
new MutationObserver(killPayment).observe(document.documentElement,{childList:true,subtree:true});

function initHeader(){
  var h=document.getElementById('site-header');
  if(!h)return;
  var t=false;
  window.addEventListener('scroll',function(){
    if(!t){requestAnimationFrame(function(){h.classList.toggle('scrolled',window.scrollY>24);t=false;});t=true;}
  },{passive:true});
}

function initMobileNav(){
  var btn=document.getElementById('burger-btn'),nav=document.getElementById('mobile-nav');
  if(!btn||!nav)return;
  btn.addEventListener('click',function(){
    var o=btn.classList.toggle('is-open');
    nav.classList.toggle('is-open',o);
    btn.setAttribute('aria-expanded',String(o));
  });
}

function initAccordions(){
  document.querySelectorAll('.accordion-trigger').forEach(function(trigger){
    trigger.addEventListener('click',function(){
      var isOpen=trigger.getAttribute('aria-expanded')==='true';
      var content=trigger.nextElementSibling;
      if(!content)return;
      trigger.setAttribute('aria-expanded',String(!isOpen));
      content.hidden=isOpen;
    });
  });
}

function initStickyATC(){
  var atcBtn=document.getElementById('atc-btn');
  var stickyBar=document.getElementById('sticky-atc');
  var stickyBtn=document.getElementById('sticky-atc-btn');
  if(!atcBtn||!stickyBar)return;
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      stickyBar.classList.toggle('is-visible',!e.isIntersecting);
      stickyBar.setAttribute('aria-hidden',e.isIntersecting?'true':'false');
    });
  },{rootMargin:'0px 0px -40px 0px'});
  obs.observe(atcBtn);
  if(stickyBtn){
    stickyBtn.addEventListener('click',function(){
      var id=document.getElementById('variant-id');
      if(!id||!id.value)return;
      stickyBtn.disabled=true;stickyBtn.textContent='...';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:parseInt(id.value),quantity:1})})
      .then(function(r){return r.json();})
      .then(function(d){if(d.status){notif('Échec',true);}else{notif('Ajouté au panier ✓');badge();}})
      .catch(function(){notif('Erreur réseau',true);})
      .finally(function(){stickyBtn.disabled=false;stickyBtn.textContent='Ajouter';});
    });
  }
}

function initBuyNow(){
  var btn=document.getElementById('buy-now-btn');
  if(!btn)return;
  btn.addEventListener('click',function(){
    var id=document.getElementById('variant-id');
    if(!id||!id.value)return;
    btn.disabled=true;btn.textContent='...';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:parseInt(id.value),quantity:1})})
    .then(function(r){return r.json();})
    .then(function(d){
      if(d.status){btn.disabled=false;btn.textContent='Acheter maintenant';notif('Échec',true);}
      else{window.location.href='/checkout';}
    })
    .catch(function(){btn.disabled=false;btn.textContent='Acheter maintenant';notif('Erreur réseau',true);});
  });
}

function initReviewForm(){
  var form=document.getElementById('review-form');
  var picker=document.getElementById('star-picker');
  var thanks=document.getElementById('review-thanks');
  if(!form||!picker)return;
  var rating=0;
  var stars=Array.prototype.slice.call(picker.querySelectorAll('.star-pick'));
  function paintStars(n,cls){stars.forEach(function(s,i){s.classList.toggle(cls,i<n);});}
  stars.forEach(function(star){
    var v=parseInt(star.getAttribute('data-v'));
    star.addEventListener('mouseenter',function(){paintStars(v,'hovered');});
    star.addEventListener('mouseleave',function(){paintStars(0,'hovered');paintStars(rating,'chosen');});
    star.addEventListener('click',function(){rating=v;paintStars(0,'hovered');paintStars(rating,'chosen');});
    star.addEventListener('keydown',function(e){if(e.key===' '||e.key==='Enter'){rating=v;paintStars(0,'hovered');paintStars(rating,'chosen');}});
  });
  form.addEventListener('submit',function(e){
    e.preventDefault();
    var nameEl=document.getElementById('rf-name'),textEl=document.getElementById('rf-text');
    if(!nameEl||!nameEl.value.trim()){notif('Merci d\'indiquer votre prénom.',true);return;}
    if(!textEl||!textEl.value.trim()){notif('Merci d\'écrire votre avis.',true);return;}
    if(!rating){notif('Merci de sélectionner une note.',true);return;}
    form.hidden=true;
    if(thanks)thanks.hidden=false;
  });
}

function initGSAP(){
  if(reduceMotion){return;}  /* Skip all animations if user prefers */
  if(!window.gsap||!window.ScrollTrigger){setTimeout(initGSAP,100);return;}
  gsap.registerPlugin(ScrollTrigger);
  var E='power2.out';

  var heroImg=document.querySelector('.ch__bg-img');
  if(heroImg&&!isMobile){
    gsap.to(heroImg,{yPercent:22,ease:'none',scrollTrigger:{trigger:'.ch-1',start:'top top',end:'bottom top',scrub:true}});
  }

  var heroTitle=document.querySelector('.ch__display');
  if(heroTitle){
    var heroLines=heroTitle.innerHTML.split(/<br\s*\/?>/i);
    heroTitle.innerHTML=heroLines.map(function(line){
      return line.trim().split(/\s+/).filter(Boolean).map(function(w){
        return '<span class="hw" style="display:inline-block;overflow:hidden;vertical-align:bottom"><span class="hwi" style="display:inline-block">'+w+'</span></span>';
      }).join(' ');
    }).join('<br>');
    gsap.from(heroTitle.querySelectorAll('.hwi'),{yPercent:110,opacity:0,duration:1.1,stagger:0.09,ease:'power3.out',delay:0.3});
  }

  gsap.from(['.ch__tag','.ch__caption','.ch__cta'],{opacity:0,y:30,duration:1,stagger:0.15,ease:E,delay:0.9});

  var manifesto=document.getElementById('manifesto-text');
  if(manifesto){
    var lines=manifesto.innerHTML.split(/<br\s*\/?>/i);
    manifesto.innerHTML='';
    var allInners=[];
    lines.forEach(function(line,li){
      var words=line.trim().split(/\s+/).filter(Boolean);
      words.forEach(function(w,wi){
        var wrap=document.createElement('span');
        wrap.style.cssText='display:inline-block;overflow:hidden;vertical-align:bottom';
        var inner=document.createElement('span');
        inner.className='mi';inner.style.display='inline-block';inner.textContent=w;
        wrap.appendChild(inner);
        manifesto.appendChild(wrap);
        if(wi<words.length-1)manifesto.appendChild(document.createTextNode(' '));
        allInners.push(inner);
      });
      if(li<lines.length-1)manifesto.appendChild(document.createElement('br'));
    });
    if(isMobile){
      gsap.from(allInners,{yPercent:80,opacity:0,duration:0.6,stagger:0.03,ease:E,scrollTrigger:{trigger:'.ch-2',start:'top 80%',once:true}});
    }else{
      gsap.from(allInners,{yPercent:110,opacity:0,stagger:0.04,ease:E,scrollTrigger:{trigger:'.ch-2',start:'top 65%',end:'center 30%',scrub:0.8}});
    }
  }

  gsap.from(['.ch__overline','.ch-2 .btn'],{opacity:0,y:24,duration:0.8,stagger:0.2,ease:E,scrollTrigger:{trigger:'.ch-2',start:'top 55%',once:true}});

  if(!isMobile){
    gsap.fromTo('.ch3-img',{scale:1.08},{scale:1,ease:'none',scrollTrigger:{trigger:'.ch-4',start:'top bottom',end:'top top',scrub:1.5}});
  }

  var ch3Info=document.querySelectorAll('.ch3-info > *');
  if(ch3Info.length)gsap.from(ch3Info,{opacity:0,x:isMobile?30:60,duration:0.9,stagger:0.15,ease:E,scrollTrigger:{trigger:'.ch3-info',start:'top 70%',once:true}});

  var valueRows=document.querySelectorAll('.value-row');
  if(valueRows.length)gsap.from(valueRows,{opacity:0,x:-30,duration:0.7,stagger:0.13,ease:E,scrollTrigger:{trigger:'.values',start:'top 72%',once:true}});

  var magItems=document.querySelectorAll('.mag-item');
  if(magItems.length)gsap.from(magItems,{opacity:0,y:50,scale:0.96,duration:0.8,stagger:0.1,ease:E,scrollTrigger:{trigger:'.mag-grid',start:'top 78%',once:true}});

  var quote=document.querySelector('.ch6-quote');
  if(quote){
    var qLines=quote.innerHTML.split(/<br\s*\/?>/i);
    quote.innerHTML='';
    qLines.forEach(function(line){
      var div=document.createElement('div');div.style.cssText='overflow:hidden;display:block';
      var inner=document.createElement('span');inner.style.display='block';inner.className='qi';inner.innerHTML=line.trim();
      div.appendChild(inner);quote.appendChild(div);
    });
    gsap.from(quote.querySelectorAll('.qi'),{yPercent:100,opacity:0,duration:1,stagger:0.18,ease:'power3.out',scrollTrigger:{trigger:'.ch-6',start:'top 65%',once:true}});
  }
  gsap.from('.ch-6 .btn',{opacity:0,y:20,duration:0.8,ease:E,scrollTrigger:{trigger:'.ch-6',start:'top 55%',once:true}});

  document.querySelectorAll('.products-grid,.collection-grid').forEach(function(grid){
    var cards=grid.querySelectorAll('.product-card');
    if(!cards.length)return;
    gsap.from(cards,{opacity:0,y:30,duration:0.6,stagger:0.06,ease:E,scrollTrigger:{trigger:grid,start:'top bottom',once:true}});
  });

  var crossCards=document.querySelectorAll('.cross-sell .product-card');
  if(crossCards.length)gsap.from(crossCards,{opacity:0,y:30,duration:0.6,stagger:0.08,ease:E,scrollTrigger:{trigger:'.cross-sell',start:'top 80%',once:true}});

  var storyText=document.querySelectorAll('.piece-story__text > *');
  if(storyText.length)gsap.from(storyText,{opacity:0,x:isMobile?20:60,duration:0.8,stagger:0.15,ease:E,scrollTrigger:{trigger:'.piece-story__text',start:'top 75%',once:true}});

  if(!isMobile){
    var storyImg=document.querySelector('.piece-story__media img');
    if(storyImg)gsap.fromTo(storyImg,{scale:1.06},{scale:1,ease:'none',scrollTrigger:{trigger:'.piece-story',start:'top bottom',end:'top top',scrub:1.2}});
  }

  var reviewCards=document.querySelectorAll('.review-card');
  if(reviewCards.length)gsap.from(reviewCards,{opacity:0,y:30,duration:0.6,stagger:0.08,ease:E,scrollTrigger:{trigger:'.reviews-grid',start:'top 85%',once:true}});

  var rfWrap=document.querySelector('.review-form-wrap');
  if(rfWrap)gsap.from(rfWrap,{opacity:0,y:30,duration:0.7,ease:E,scrollTrigger:{trigger:rfWrap,start:'top 85%',once:true}});

  var instaItems=document.querySelectorAll('.insta-item');
  if(instaItems.length)gsap.from(instaItems,{opacity:0,scale:0.92,duration:0.5,stagger:0.05,ease:E,scrollTrigger:{trigger:'.insta-grid',start:'top 85%',once:true}});

  document.querySelectorAll('.section-head').forEach(function(el){
    gsap.from(el.children,{opacity:0,y:30,duration:0.7,stagger:0.1,ease:E,scrollTrigger:{trigger:el,start:'top 80%',once:true}});
  });

  window.addEventListener('load',function(){ScrollTrigger.refresh();});
}

function initGallery(){
  var mainImg=document.getElementById('gallery-main-img');
  var thumbs=document.querySelectorAll('.gallery-thumb');
  var prev=document.getElementById('gallery-prev');
  var next=document.getElementById('gallery-next');
  if(!mainImg)return;
  var imgs=[],cur=0;
  thumbs.forEach(function(t,i){imgs.push(t.getAttribute('data-src'));t.addEventListener('click',function(){goTo(i);});});
  if(!imgs.length)return;
  function goTo(i){cur=i;mainImg.style.opacity='0';setTimeout(function(){mainImg.src=imgs[i];mainImg.style.opacity='1';},220);thumbs.forEach(function(t,idx){t.classList.toggle('active',idx===i);});}
  mainImg.style.transition='opacity .25s ease';
  if(prev)prev.addEventListener('click',function(){goTo((cur-1+imgs.length)%imgs.length);});
  if(next)next.addEventListener('click',function(){goTo((cur+1)%imgs.length);});
}

function initVariants(){
  var form=document.getElementById('product-form');
  if(!form||!window.__productData)return;
  var data=window.__productData;
  var idInput=document.getElementById('variant-id');
  var sel={};
  var firstV=data.variants.find(function(v){return v.available;})||data.variants[0];
  data.options.forEach(function(o,i){sel[o]=firstV.options[i];});
  function find(){return data.variants.find(function(v){return data.options.every(function(o,i){return v.options[i]===sel[o];});});}
  function ui(v){
    if(!v)return;
    if(idInput)idInput.value=v.id;
    var price=fmt(v.price);
    document.querySelectorAll('.js-price').forEach(function(pe){pe.textContent=price;});
    document.querySelectorAll('.js-sticky-price').forEach(function(pe){pe.textContent=price;});
    document.querySelectorAll('.js-compare').forEach(function(ce){ce.textContent=v.compare_at_price>v.price?fmt(v.compare_at_price):'';ce.style.display=v.compare_at_price>v.price?'':'none';});
    var atc=document.getElementById('atc-btn');
    if(atc){atc.disabled=!v.available;atc.textContent=v.available?'Ajouter au panier':'Épuisé';}
    var sBtn=document.getElementById('sticky-atc-btn');
    if(sBtn)sBtn.disabled=!v.available;
    if(v.featured_image&&v.featured_image.src){
      var mi=document.getElementById('gallery-main-img');
      if(mi){mi.style.opacity='0';setTimeout(function(){mi.src=v.featured_image.src;mi.style.opacity='1';},220);}
    }
  }
  form.querySelectorAll('.variant-btn,.swatch-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var o=btn.getAttribute('data-option'),v=btn.getAttribute('data-value');
      sel[o]=v;
      btn.closest('.variant-options').querySelectorAll('.variant-btn,.swatch-btn').forEach(function(b){b.classList.remove('active');b.setAttribute('aria-pressed','false');});
      btn.classList.add('active');btn.setAttribute('aria-pressed','true');
      var lbl=btn.closest('.variant-group')&&btn.closest('.variant-group').querySelector('.variant-group-selected');
      if(lbl)lbl.textContent=v;
      ui(find());
    });
  });
  ui(firstV);
}

function initCartForm(){
  var form=document.getElementById('product-form');
  if(!form)return;
  form.addEventListener('submit',function(e){
    e.preventDefault();
    var id=document.getElementById('variant-id');if(!id||!id.value)return;
    var btn=document.getElementById('atc-btn'),orig=btn?btn.textContent:'';
    if(btn){btn.disabled=true;btn.textContent='Ajout…';}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:parseInt(id.value),quantity:1})})
    .then(function(r){return r.json();})
    .then(function(d){if(d.status){notif('Échec : '+(d.description||'Réessayez'),true);}else{notif('Ajouté au panier ✓');badge();}})
    .catch(function(){notif('Erreur réseau',true);})
    .finally(function(){if(btn){btn.disabled=false;btn.textContent=orig||'Ajouter au panier';}});
  });
}

function initCartQty(){
  document.querySelectorAll('.cart-item__qty').forEach(function(w){
    var inp=w.querySelector('input'),key=w.closest('.cart-item')&&w.closest('.cart-item').dataset.key;
    var m=w.querySelector('[data-q="minus"]'),p=w.querySelector('[data-q="plus"]');
    function ch(q){fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:q})}).then(function(){location.reload();});}
    if(m)m.addEventListener('click',function(){var v=Math.max(0,parseInt(inp.value)-1);inp.value=v;ch(v);});
    if(p)p.addEventListener('click',function(){var v=parseInt(inp.value)+1;inp.value=v;ch(v);});
  });
}

function badge(){fetch('/cart.js').then(function(r){return r.json();}).then(function(c){var b=document.querySelector('.header__cart-badge');if(c.item_count>0){if(!b){b=document.createElement('span');b.className='header__cart-badge';var l=document.querySelector('.header__cart');if(l)l.appendChild(b);}b.textContent=c.item_count;}else if(b)b.remove();});}
var nt;
function notif(msg,err){var el=document.getElementById('notification');if(!el)return;el.textContent=msg;el.style.background=err?'var(--red)':'var(--ink)';el.classList.add('show');clearTimeout(nt);nt=setTimeout(function(){el.classList.remove('show');},3200);}
function fmt(c){return new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}).format(c/100);}

function init(){
  initPageEnter();
  initHeader();
  initMobileNav();
  initAccordions();
  initStickyATC();
  initBuyNow();
  initReviewForm();
  initGSAP();
  initGallery();
  initVariants();
  initCartForm();
  initCartQty();
}

if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}

})();
